import React, { useState, useEffect } from 'react';
import YoutubeVideoPopup from '../YoutubeVideoPopup/YoutubeVideoPopup';

interface SuperstarReviewItemProps {
  link: string;
  image: string;
}

const SuperstarReviewItem: React.FC<SuperstarReviewItemProps> = ({
  link,
  image,
}) => {
  const [show, setShow] = useState(false);

  /**
   * if modal is open don't scroll window
   */
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [show]);

  return (
    <div className="bg-bgColor8 p-3.75 w-full rounded-md">
      <div className="relative w-full bg-contain bg-center bg-no-repeat">
        <img src={image} alt="youtube" className="w-full rounded-md" />
        <div
          className="absolute left-0 top-0 flex h-full w-full cursor-pointer items-center justify-center"
          onClick={() => setShow(true)}
        >
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#1a1a1a] opacity-90 hover:bg-[#333333]">
            <img
              src="/assets/icons/Play.svg"
              alt="play-video-icon"
              className="ml-0.75"
            />
          </div>
        </div>
      </div>
      <YoutubeVideoPopup
        link={link}
        show={show}
        setShow={setShow}
        onClose={() => setShow(false)}
      />
    </div>
  );
};

export default SuperstarReviewItem;
